import axios from 'axios';
import { $authHost, $host } from '.';
import { setCookie } from '@/utils/cookies';

export type GetClientResponse = {
  result: boolean;
  data: {
    id: string;
    last_name: string;
    name: string;
    second_name: string;
    email: string;
    phone: string;
    birthday: string;
    sex: number;
    club: {
      id: string;
      name: string;
    };
    cards: Array<any>;
    promocodes: Array<any>;
    tags: Array<any>;
    edit_allowed: boolean;
    auth_message: string;
    id_cards: Array<any>;
    photo: any;
    appointments_to_rate: Array<any>;
    cars: Array<any>;
    certificates: Certificates[];
  };
};

export type PostAuthClientsResponse = {
  result: boolean;
  data: {
    user_token: string;
    id: string;
    user_tokens: Array<string>;
  };
};
export type Certificates = {
  name: string;
  end_date: string;
};
export const confirmPhone = async (phone: string) => {
  await axios
    .post(
      `${import.meta.env.VITE_API_URL}/confirm_phone`,
      {
        phone: phone,
        auth_type: 'sms',
      },
      {
        headers: {
          'Content-Type': 'application/json',
          apikey: '0bd6faba-8de1-490d-9585-7281bcde2a4e',
        },
      },
    )
    .then((res) => {
      const response = res.data.result;
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const confirmPhoneCode = async (phone: string, code: string) => {
  return await axios
    .post(
      `${import.meta.env.VITE_API_URL}/confirm_phone`,
      {
        phone: phone,
        auth_type: 'sms',
        confirmation_code: code,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          apikey: '0bd6faba-8de1-490d-9585-7281bcde2a4e',
        },
      },
    )
    .then((res) => {
      localStorage.setItem('pass_token', res.data.data.pass_token);
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const setPasswordReg = async (phone: string, pass: string, token: string) => {
  await axios
    .post(
      `${import.meta.env.VITE_API_URL}/password`,
      {
        phone: phone,
        password: pass,
        pass_token: token,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          apikey: '0bd6faba-8de1-490d-9585-7281bcde2a4e',
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export async function authClient(phone: string, password: string) {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_API_URL}/auth_client`,
      {
        phone: phone,
        password: password,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          apikey: '0bd6faba-8de1-490d-9585-7281bcde2a4e',
        },
      },
    );
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function getClient(usertoken?: string) {
  try {
    const response = await $authHost.request<GetClientResponse>({
      url: '/client',
      ...(usertoken && {
        headers: { usertoken: usertoken },
      }),
    });
    return response;
  } catch (error) {
    console.error(error);
    setCookie('isAuth', false);
    window.location.reload();
    return {
      data: {
        result: false,
        data: {
          id: '',
          last_name: '',
          name: '',
          second_name: '',
          email: '',
          phone: '',
          birthday: '',
          sex: 0,
          club: {
            id: '',
            name: '',
          },
          cards: [],
          promocodes: [],
          tags: [],
          edit_allowed: false,
          auth_message: '',
          id_cards: [],
          photo: null,
          appointments_to_rate: [],
          cars: [],
          certificates: [],
        },
      },
    };
  }
}

export async function authClients(phone?: string, password?: string) {
  return $host.request<PostAuthClientsResponse>({
    method: 'POST',
    url: '/auth_client_new',
    data: {
      phone,
      password,
    },
  });
}
